export const FETCH_ALL_BLOGS = "FETCH_ALL_BLOGS";
export const FETCH_PENDING_BLOGS = "FETCH_PENDING_BLOGS";
export const FETCH_BLOG = "FETCH_BLOG";
export const CREATE_BLOG = "CREATE_BLOG";
export const UPDATE_BLOG = "UPDATE_BLOG";
export const DELETE_BLOG = "DELETE_BLOG";
